import { createSlice } from "@reduxjs/toolkit";
import { faqUserGuideAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqUserGuideSlice = createSlice({
  name: "faqUserGuide",
  initialState: data,
  reducers: {
    faqUserGuideSlice(state) {
      state.isLoading = false;
    },
    faqUserGuideSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqUserGuideSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqUserGuideSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqUserGuideHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqUserGuideAction.faqUserGuideSlice());
    const response: any = await faqUserGuideAPI();
    dispatch(faqUserGuideAction.faqUserGuideSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqUserGuideAction.faqUserGuideSliceFailure(e?.response?.data?.message));
    dispatch(faqUserGuideAction.faqUserGuideSliceReset());
  }
};
export default faqUserGuideSlice.reducer;
export const faqUserGuideAction = faqUserGuideSlice.actions;
